<script>
import { angularInvoke } from "/vodalys/vvuejs";
export default {
  components: {},
  methods: {
    async create() {
      let zis = this;

      angularInvoke(function (
        v17Modal,
        $rootScope,
        $rootElement,
        vTranslateService
      ) {
        v17Modal.inputAndDate($rootScope, $rootElement.find("body"), {
          classes: "projector-item-modal",
          title: vTranslateService.translate("New Event"),
          inputLabel: "Title",
          date: new Date(),
          placeholder: "Event",
          ok: function (title, date) {
            zis.pending = true;

            return new Promise((resolve, reject) => {
              zis.handler
                .action(zis.component["#id"], "create", [title, date])
                .then(
                  function () {
                    zis.promiseResolve = resolve;
                    zis.promiseReject = reject;
                  },
                  function () {
                    reject();
                    zis.pending = false;
                  }
                );
            });
          },
          okLabel: "Create",
          yesType: "highlight",
        });
      });
    },
  },
  watch: {
    "component.last_created_url": function (url) {
      if (url) {
        window.location.hash = url;

        this.pending = false;

        if (this.promiseResolve) this.promiseResolve();
      }
    },
    "component.task_state": function (task_state) {
      if (task_state == "error" && this.component.task_last_error) {
        this.vnotification_service_js.add({
          "#type": "vnotification:js",
          label: this.component.task_last_error,
          delay: 15000,
          severity: 2,
        });

        this.pending = false;

        if (this.promiseReject) this.promiseReject();
      }
    },
  },
  props: ["component", "handler", "data"],
  data: function () {
    return {
      pending: false,
      promiseResolve: null,
      promiseReject: null,
    };
  },
  computed: {},
  mounted: function () {
    this.vnotification_service_js = angularInvoke(
      (vnotification_service_js) => vnotification_service_js
    );
  },
};
</script>

<template>
  <div class="home24-create">
    <f-button
      v-if="component.multi_projects"
      :type="data && data.type ? data.type : 'tertiary'"
      href="#/new"
      >{{ $vt("New Event") }} <f-icon icon="fa6-plus"></f-icon
    ></f-button>
    <f-button
      v-if="!component.multi_projects"
      :type="data && data.type ? data.type : 'tertiary'"
      @click="create()"
      >{{ $vt("New Event") }} <f-icon icon="fa6-plus"></f-icon
    ></f-button>
  </div>
</template>

<style lang="scss">
.home24-craete {
}
</style>